var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAlert)?_c('v-alert',{staticStyle:{"grid-area":"price"},attrs:{"icon":"mdi-cash-usd-outline","text":"","type":"warning","outlined":""}},[(_vm.showReanalysisAlert)?_c('span',[_vm._v("Upon submission, VCGS will review this request and contact you, if necessary, regarding feasibility and pricing. ")]):_vm._e(),(_vm.showVariantReviewAlert)?_c('span',[_vm._v(" Upon submission, VCGS will review this request and contact you, if necessary, regarding pricing ")]):_vm._e(),(
      !_vm.summaryScreen &&
        !_vm.showVariantReviewAlert &&
        !_vm.showReanalysisAlert
    )?_c('span',[_vm._v("Price: $"+_vm._s(_vm.price)+" AUD ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }